import actions from './de-DE/actions';
import admin from './de-DE/admin';
import common from './de-DE/common';
import error from './de-DE/error';
import features from './de-DE/features';
import form from './de-DE/form';
import menu from './de-DE/menu';
import messages from './de-DE/messages';
import price from './de-DE/price';
import scheduler from './de-DE/scheduler';
import subscriptions from './de-DE/subscriptions';
import table from './de-DE/table';
import tenants from './de-DE/tenants';

export default {
  ...actions,
  ...admin,
  ...common,
  ...error,
  ...form,
  ...menu,
  ...features,
  ...messages,
  ...price,
  ...table,
  ...tenants,
  ...subscriptions,
  ...scheduler,
};
